<div class="api-keys-settings">
  <div class="api-keys-header">
    <h3 class="api-keys-title">API Keys</h3>
  </div>
  <div class="api-keys-content">
    <table class="api-keys-table">
      <thead>
        <tr>
          <th>PREFIX</th>
          <th>CREATED</th>
          <!--          <th>Revoked</th>-->
          <!--          <th>Expiry Date</th>-->
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (key of apiKeys; track key) {
          <tr>
            <td>
              <div class="api-key-id-wrapper">
                <span class="api-key-id">{{ key.id }}</span>
              </div>
            </td>
            <td>{{ key.created | date: 'MMM d, y' }}</td>
            <!--          <td>{{ key.revoked ? 'Yes' : 'No' }}</td>-->
            <!--          <td>{{ key.expiry_date | date: 'MMM d, y' }}</td>-->
            <td class="actions-cell">
              <div class="middle-button"><button class="button" (click)="revokeApiKey(key.id)">Revoke</button></div>
              <div class="middle-button">
                <button class="button" >
                  <inline-svg src="copy.svg" className="copy-icon"
                    (click)="copyToClipboard(key.id)"
                    color="#A5B5BD"
                    hoverColor="#7F8F98"
                    activeColor="#85BBF3"
                  ></inline-svg>
                </button></div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="api-keys-actions">
      <button mat-button class="frmg-primary-button" ><div class="new-api-key-button" (click)="createApiKey()">New API Keys</div></button>
    </div>
  </div>